import { useEffect, useMemo, useState } from "react";
import { scheduleAPI } from "../../api/client";
import { buildCalendar } from "../../utils/ganttModel";

// Org working days + public holidays as a Gantt calendar. Returns null until
// loaded; a failed load falls back to the Mon–Fri default rather than erroring.
export default function useOrgCalendar() {
  const [orgSchedule, setOrgSchedule] = useState(null);

  useEffect(() => {
    let cancelled = false;
    scheduleAPI
      .getOrg()
      .then((resp) => !cancelled && setOrgSchedule(resp.data || {}))
      .catch(() => !cancelled && setOrgSchedule({}));
    return () => {
      cancelled = true;
    };
  }, []);

  return useMemo(
    () => (orgSchedule ? buildCalendar(orgSchedule) : null),
    [orgSchedule],
  );
}
